var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 131,
    viewBox: "0 0 125 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7289 129H93.8397",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0456 9.4222L14.8405 7.67631C16.1001 6.88715 15.4946 4.94129 14.008 5.00616L10.7157 5.15211C10.1967 5.17373 9.70474 4.91428 9.42363 4.47646L7.67748 1.682C6.88819 0.422602 4.942 1.02797 5.00687 2.51439L5.15281 5.80614C5.17444 6.32504 4.91495 6.81688 4.47705 7.09795L1.68212 8.84384C0.422504 9.63299 1.02797 11.5788 2.51464 11.514L5.80696 11.368C6.32594 11.3464 6.8179 11.6059 7.09902 12.0437L8.84517 14.8381C9.63446 16.0975 11.5807 15.4922 11.5158 14.0058L11.3698 10.714C11.3482 10.1897 11.6023 9.69786 12.0456 9.4222Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3698 10.714C11.3482 10.1951 11.6077 9.70326 12.0456 9.4222L14.8405 7.67631C16.1001 6.88715 15.4946 4.94129 14.008 5.00616L10.7157 5.15211C10.1967 5.17373 9.70474 4.91428 9.42363 4.47646L7.67748 1.682C6.88819 0.422602 4.942 1.02797 5.00687 2.51439L5.15281 5.80614C5.17444 6.32504 4.91495 6.81688 4.47705 7.09795L1.68212 8.84384C0.422504 9.63299 1.02797 11.5789 2.51464 11.514L5.80696 11.368C6.32594 11.3464 6.81791 11.6059 7.09902 12.0437L8.84517 14.8381C9.63446 16.0975 11.5807 15.4922 11.5158 14.0058",
    stroke: "black",
    strokeWidth: 1.31075,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.488 75.9613L119.19 72.8263C119.055 71.4156 117.136 71.1021 116.557 72.3939L115.276 75.2694C115.076 75.7235 114.644 76.0316 114.146 76.0802L111.011 76.3775C109.6 76.5126 109.286 78.4315 110.578 79.0098",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.452 80.3014C113.907 80.5014 114.215 80.9338 114.263 81.431L114.561 84.566C114.696 85.9768 116.62 86.2903 117.193 84.9984L118.475 82.1229C118.675 81.6689 119.107 81.3608 119.605 81.3121L122.74 81.0148C124.151 80.8797 124.465 78.9609 123.173 78.3825L120.296 77.1015",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4727 74.5809L12.4727 103.65",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0632 98.5261V111.877",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.737 93.6023V103.45",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0226 99.1583V103.451",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8774 90.6509H27.6426C25.2477 90.6509 23.3016 88.7105 23.3016 86.316V77.3218H85.5363V86.316C85.5363 88.7105 87.4825 90.6509 89.8774 90.6509Z",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2117 15.5622V86.3158C94.2117 88.7102 92.2709 90.6507 89.876 90.6507C87.4811 90.6507 85.535 88.7102 85.535 86.3158V77.3216H27.6413L27.6413 15.5622C27.6413 13.2002 29.5551 11.2867 31.9175 11.2867L89.9356 11.2867C92.298 11.2867 94.2117 13.2002 94.2117 15.5622Z",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5737 17.972H70.9923",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0181 21.6698H73.5509",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6755 33.5785H51.5747",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6755 44.3826H51.5747",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6755 38.9778H47.5039",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6755 50.063H51.5747",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3673 60.4319H51.2665",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6755 55.4677H47.5039",
    stroke: "black",
    strokeWidth: 2.01266,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.502 47.9937L107.677 44.7526L110.955 35.8405C111.213 35.1242 110.849 34.3257 110.132 34.0674L103.528 31.6365C102.812 31.3781 102.013 31.7421 101.754 32.4584L98.476 41.3705L89.6512 38.1293C88.8874 37.8475 88.0296 38.2349 87.7476 39.0099L85.3861 45.4093C85.1041 46.1725 85.4919 47.0297 86.2675 47.3115L95.0922 50.5527L91.8142 59.4648C91.5557 60.181 91.92 60.9795 92.6368 61.2379L99.2407 63.6688C99.9575 63.9271 100.757 63.5631 101.015 62.8469L104.293 53.9348L113.118 57.1759C113.882 57.4578 114.739 57.0703 115.021 56.2953L117.383 49.8961C117.665 49.1211 117.265 48.2756 116.502 47.9937Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M103.483 56.1275L104.294 53.92L113.119 57.1612C113.882 57.443 114.74 57.0556 115.022 56.2806L117.384 49.8812C117.666 49.118 117.278 48.2608 116.502 47.979L107.678 44.7378L110.956 35.8257C111.214 35.1094 110.85 34.3109 110.133 34.0526L103.529 31.6217C102.812 31.3634 102.013 31.7273 101.755 32.4436L98.4768 41.3557L89.652 38.1145C88.8882 37.8327 88.0305 38.2201 87.7485 38.9951L85.3869 45.3944C85.105 46.1577 85.4928 47.0148 86.2683 47.2967L95.093 50.5379L91.815 59.4499C91.5566 60.1662 91.9209 60.9647 92.6377 61.223L99.2416 63.6539C99.9584 63.9123 100.757 63.5483 101.016 62.8321L102.026 60.0962",
    stroke: "black",
    strokeWidth: 2.38587,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0977 34.772L96.9111 37.9898L94.5962 37.1323",
    stroke: "black",
    strokeWidth: 2.38587,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.fd5f7deb0b3c80db3781fa4569d468b1.svg";
export { ForwardRef as ReactComponent };